import * as React from 'react'
import { Global, css } from '@emotion/react'
import Wheel1 from './svgs/wheel-1'
import Wheel2 from './svgs/wheel-2'
import Wheel3 from './svgs/wheel-3'
import Wheel4 from './svgs/wheel-4'
import Wheel5 from './svgs/wheel-5'
import WheelRays from './svgs/wheel-rays'

const BASE_WIDTH = 366

const scale = size => `${(size / BASE_WIDTH) * 100}%`

const Wheel = props => {
  return (
    <>
      <Global
        styles={css`
          .wheel-parent {
            position: relative;
            width: 100%;
            max-width: ${BASE_WIDTH}px;
            aspect-ratio: 1 / 1;
            margin: 0 auto;
          }

          .wheel-size-ref {
            visibility: hidden;
            pointer-events: none;
          }

          .wheel-layer {
            position: absolute;
            inset: 0;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .wheel-1 svg {
            width: ${scale(BASE_WIDTH)};
          }
          .wheel-2 svg {
            width: ${scale(349)};
          }
          .wheel-3 svg {
            width: ${scale(317)};
          }
          .wheel-4 svg {
            width: ${scale(112)};
          }

          .wheel-pin {
            inset: unset;
            top: 0;
            left: 50%;
            transform: translate(-50%, -10%);
          }

          .wheel-pin svg {
            width: ${scale(75)};
            height: auto;
            overflow: visible;
            transform-box: fill-box;
            transform-origin: 50% 0%;
          }
          .wheel-rays-svg {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 220%;
            max-width: 900px;
            height: auto;
            pointer-events: none;
            z-index: 0;
            opacity: 0.6;
            filter: drop-shadow(0 0 6px rgba(255, 253, 251, 0.35));
          }
        `}
      />
      <div className="wheel-parent">
        {props.showRays && <WheelRays className="wheel-rays-svg" />}
        <div className="wheel-size-ref">
          <Wheel1 />
        </div>
        <div className="wheel-layer wheel-1">
          <Wheel1 />
        </div>
        <div className="wheel-layer wheel-2">
          <Wheel2 wheelRef={props.wheelRef2} />
        </div>
        <div className="wheel-layer wheel-3">
          <Wheel3 wheelRef={props.wheelRef} />
        </div>
        <div className="wheel-layer wheel-4">
          <Wheel4 />
        </div>
        <div className="wheel-layer wheel-pin">
          <Wheel5 pointerRef={props.pointerRef} />
        </div>
      </div>
    </>
  )
}

export default Wheel
